import React, { lazy, Suspense } from 'react';

const LazyPreRegistrationDetail = lazy(() => import('./PreRegistrationDetail'));

const PreRegistrationDetail = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyPreRegistrationDetail {...props} />
  </Suspense>
);

export default PreRegistrationDetail;
